import request from '../../shared/lib/request'
const rootApiUrl = process.env.REACT_APP_API_URL

function brands(client) {
  return request({
    url: `${rootApiUrl}/settings/competition/${client}/brands`,
    method: 'GET'
  })
}

function discoveryBrands() {
  return request({
    url: `${rootApiUrl}/settings/discovery/brands`,
    method: 'GET'
  })
}

function removeBrand(name) {
  return request({
    url: `${rootApiUrl}/settings/discovery/remove/${name}`,
    method: 'DELETE'
  })
}

function addBrand(name) {
  return request({
    url: `${rootApiUrl}/settings/discovery/add/${name}`,
    method: 'POST'
  })
}

function GetEntities({ page, pageSize }) {
  return request({
    url: `${rootApiUrl}/settings/entities`,
    params: { page, pageSize },
    method: 'GET'
  })
}

function DeleteEntity(id, key) {
  if (!id || !key) return null
  return request({
    url: `${rootApiUrl}/settings/entities/${id}/${key}`,
    method: 'DELETE'
  })
}

function CreateEntity(data) {
  return request({
    url: `${rootApiUrl}/settings/entities`,
    data,
    method: 'POST'
  })
}

function getXhsConfig() {
  return request({
    url: `${rootApiUrl}/settings/xhs`,
    method: 'GET'
  })
}

function getXhsBalance() {
  return request({
    url: `${rootApiUrl}/settings/xhs/balance`,
    method: 'GET'
  })
}

function addXhsKw(name) {
  return request({
    url: `${rootApiUrl}/settings/xhs/add/${name}`,
    method: 'POST'
  })
}

function removeXhsKw(name) {
  return request({
    url: `${rootApiUrl}/settings/xhs/remove/${name}`,
    method: 'DELETE'
  })
}

function toggleXhsActive() {
  return request({
    url: `${rootApiUrl}/settings/xhs/toggleActive`,
    method: 'GET'
  })
}

function saveXhsConfig(data) {
  return request({
    url: `${rootApiUrl}/settings/xhs`,
    method: 'POST',
    data
  })
}

function getUsersEntity() {
  return request({
    url: `${rootApiUrl}/userEntities`,
    method: 'GET'
  })
}

function getSpecificUsersEntity(email) {
  return request({
    url: `${rootApiUrl}/userEntities/${email}`,
    method: 'GET'
  })
}

function patchUsersRelations(data) {
  return request({
    url: `${rootApiUrl}/userEntities`,
    method: 'PATCH',
    data: { relations: data }
  })
}

const SettingsService = {
  brands,
  removeBrand,
  addBrand,
  discoveryBrands,
  getXhsConfig,
  addXhsKw,
  removeXhsKw,
  getXhsBalance,
  toggleXhsActive,
  saveXhsConfig,
  CreateEntity,
  GetEntities,
  DeleteEntity,
  getUsersEntity,
  getSpecificUsersEntity,
  patchUsersRelations
}

export default SettingsService
